import {
  createResourceKeys,
  type ResourceScopeParams,
} from "@/lib/resource-context";

const base = createResourceKeys("user_sources");

export const userSourcesKeys = {
  ...base,
  issuerCheck: ({ scope, issuer }: ResourceScopeParams & { issuer: string }) =>
    [...base.all({ scope }), "issuer-check", issuer] as const,
};
